export const arrowRightIcon = {
  body: `
<path d="M58.4085 13.0607C58.9943 12.4749 58.9943 11.5251 58.4085 10.9393L48.8626 1.39339C48.2768 0.807607 47.3271 0.807607 46.7413 1.39339C46.1555 1.97918 46.1555 2.92893 46.7413 3.51471L55.2266 12L46.7413 20.4853C46.1555 21.0711 46.1555 22.0208 46.7413 22.6066C47.3271 23.1924 48.2768 23.1924 48.8626 22.6066L58.4085 13.0607ZM0.013672 13.5L57.3479 13.5L57.3479 10.5L0.0136718 10.5L0.013672 13.5Z" fill="currentColor"/>
`,
  width: 59,
  height: 24,
};
